import { render, staticRenderFns } from "./TypeEvidenceService.vue?vue&type=template&id=42472b2f&"
import script from "./TypeEvidenceService.vue?vue&type=script&lang=js&"
export * from "./TypeEvidenceService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports